module.exports = __webpack_public_path__ + "static/img/super-chat-pass.a8c62c50.webp";